
import { Vue, Prop, Component, Watch } from "vue-property-decorator";
import notifications from "@/lib/notifications";
import {
  AgentResource,
  AgentManufacturerResource,
} from "../../../models/api/system/agents";

import { getModule } from "vuex-module-decorators";
import SystemModule from "@/store/modules/system";
import router from "@/router";

const systemModule = getModule(SystemModule);

interface AgentManufacturerResourceSelect {
  manufacturer: AgentManufacturerResource;
  isSelected: boolean;
}
@Component({
  components: {}
})

export default class ManageManufacturers extends Vue {
  @Prop()
  agent:AgentResource;

  @Prop()
  public agentManufacturers:Array<AgentManufacturerResource>;

  filterString:string='';
  loading: boolean = false;
  loadingPage: boolean = false;

  agentManufacturer: AgentManufacturerResource = {
    agentId: null,
    manufacturerCode: null,
    agentManufacturerCode: null,
    name: null,
    isActive: true
  };
  isManufacturerModalVisible: boolean = false;

  addAgentManufacturer() {
    this.agentManufacturer = {
      agentId: this.agent.id,
      manufacturerCode: null,
      agentManufacturerCode: null,
      name: null,
      isActive: true
    };

    this.isManufacturerModalVisible = true;
  }

  editAgentManufacturer(manufacturerCode: string) {
    let clone = this.agentManufacturers.find(x => x.manufacturerCode === manufacturerCode);
    clone = { ...clone };

    this.agentManufacturer = clone;
    this.isManufacturerModalVisible = true;
  }

  async saveAgentManufacturer() {
    try {
      this.agentManufacturer.agentId = this.agent.id;
      if (this.agentManufacturer.manufacturerCode === null) {
        await systemModule.postAgentManufacturer(this.agentManufacturer);
      } else {
        await systemModule.putAgentManufacturer(this.agentManufacturer);
      }
      notifications.success("Success", `Manufacturer saved.`);
    } catch (error) {
      notifications.error("Save Failed", "Unable to save manufacturer.", error);
    }

    this.$emit("updated");
  }

  done() {
    router.push(`/admin/agents`);
  }
}
